<template>
  <IconSvgBase :class="$style.icon" :view-width="24" :view-height="24">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.25 11.25H12.75V6.75C12.75 6.33525 12.414 6 12 6C11.586 6 11.25 6.33525 11.25 6.75V11.25H6.75C6.336 11.25 6 11.5852 6 12C6 12.4148 6.336 12.75 6.75 12.75H11.25V17.25C11.25 17.6648 11.586 18 12 18C12.414 18 12.75 17.6648 12.75 17.25V12.75H17.25C17.664 12.75 18 12.4148 18 12C18 11.5852 17.664 11.25 17.25 11.25ZM12 1.99988C6.486 1.99988 2 6.48588 2 11.9999C2 17.5139 6.486 21.9999 12 21.9999C17.514 21.9999 22 17.5139 22 11.9999C22 6.48588 17.514 1.99988 12 1.99988Z"
    />
  </IconSvgBase>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import IconSvgBase from '@/components/icons/IconSvgBase.vue'

export default defineComponent({
  name: 'IconAddCircle',
  components: {
    IconSvgBase,
  },
})
</script>

<style lang="scss" module>
.icon {
  $size: 1em;

  width: $size;
  height: $size;

  &__path {
    color: inherit;
    fill: currentcolor;
  }
}
</style>
